<template>
  <div style="overflow: auto">
  	<table class="table">
  		<thead>
        <tr style="background-color: #6b6b6b;">
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.parentId") }}</span>
            </div>
          </td>
          <td class="tdBorder orderDate">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.subscriptionDate") }}</span>
            </div>
          </td>
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.status") }}</span>
            </div>
          </td>
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.periodCountLimit") }}</span>
            </div>
          </td>
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("global.action") }}</span>
            </div>
          </td>
        </tr>
	    </thead>
	    <tbody>
	    	<template v-for="order in orders.data" :key="order.id">
	    		<tr>
		    		<td class="bodytr font-weight-bold">
	            {{ order.id }}
	          </td>
	          <td class="bodytr orderDate">
	            <span class="">{{ dateFormat(order.created_at) }}</span>
	          </td>
	          <td class="bodytr">
	            <span v-if="order.m_status == 'pending_payment'" class="badge badge-warning text-capitalize">
	              {{ t(`orders.mStatus.${order.m_status}`) }}
	            </span>

	            <span v-else-if="order.m_status == 'processing'" class="badge badge-info text-capitalize">
	              {{ t(`orders.mStatus.${order.m_status}`) }}
	            </span>

	            <span v-else-if="order.m_status == 'already_delivery'" class="badge badge-info text-capitalize">
	              {{ t(`orders.mStatus.${order.m_status}`) }}
	            </span>

	            <span v-else-if="order.m_status == 'done'" class="badge badge-success text-capitalize">
	              {{ t(`orders.mStatus.${order.m_status}`) }}
	            </span>

	            <span v-else-if="order.m_status == 'abnormal_done'" class="badge badge-danger text-capitalize">
	              {{ t(`orders.mStatus.${order.m_status}`) }}
	            </span>

	            <span v-else class="badge badge-dark text-capitalize">
	              {{ order.m_status }}
	            </span>
	          </td>
	          <td class="bodytr">{{ order.period_count }}/{{ order.period_count_limit }}</td>
	          <td class="bodytr">
	          	<button v-if="!order.display" class="btn btn-primary p-2 mr-2 top-margin" @click="onClickSubData(order)">
	          		{{ t("orders.showInfo") }}
	            </button>
	            <button v-if="order.display" class="btn btn-outline-accent p-2 mr-2 top-margin" @click="onClickSubData(order)">
	              {{ t("orders.hideInfo") }}
	            </button>
	          </td>
		    	</tr>
		    	<tr v-if="order.display">
		    		<td colspan="5">
		    			<table class="table" style="background-color: #6b6b6b3b;">
	              <thead>
	                <tr style="background-color: #6b6b6ba3;">
	                  <td class="tdBorder">
	                  	<div>
					              <span class="d-block spandHeadO">{{ t("orders.periodCount") }}</span>
					            </div>
					          </td>
					          <td class="tdBorder">
	                  	<div>
					              <span class="d-block spandHeadO">{{ t("orders.id") }}</span>
					            </div>
					          </td>
					          <td class="tdBorder">
	                  	<div>
					              <span class="d-block spandHeadO">{{ t("orders.status") }}</span>
					            </div>
					          </td>
					          <td class="tdBorder">
	                  	<div>
					              <span class="d-block spandHeadO">{{ t("orders.paymentAt") }}</span>
					            </div>
					          </td>
					          <td class="tdBorder">
	                  	<div>
					              <span class="d-block spandHeadO">{{ t("orders.shippingAt") }}</span>
					            </div>
					          </td>
					          <td class="tdBorder">
	                  	<div>
					              <span class="d-block spandHeadO">{{ t("global.action") }}</span>
					            </div>
					          </td>
	                </tr>
	              </thead>
	              <tbody v-if="orders.sub_orders[order.id]">
	              	<tr v-for="sub_order in orders.sub_orders[order.id].data" :key="sub_order.id">
	              		<td class="bodytr">{{ sub_order.period_count }}</td>
	              		<td class="bodytr">{{ sub_order.id }}</td>
	              		<td class="bodytr">
	              			<span v-if="sub_order.m_status == 'pending_payment'" class="badge badge-warning text-capitalize">
					              {{ t(`orders.mStatus.${sub_order.m_status}`) }}
					            </span>

					            <span v-else-if="sub_order.m_status == 'processing'" class="badge badge-info text-capitalize">
					              {{ t(`orders.mStatus.${sub_order.m_status}`) }}
					            </span>

					            <span v-else-if="sub_order.m_status == 'already_delivery'" class="badge badge-info text-capitalize">
					              {{ t(`orders.mStatus.${sub_order.m_status}`) }}
					            </span>

					            <span v-else-if="sub_order.m_status == 'done'" class="badge badge-success text-capitalize">
					              {{ t(`orders.mStatus.${sub_order.m_status}`) }}
					            </span>

					            <span v-else-if="sub_order.m_status == 'abnormal_done'" class="badge badge-danger text-capitalize">
					              {{ t(`orders.mStatus.${sub_order.m_status}`) }}
					            </span>

					            <span v-else class="badge badge-dark text-capitalize">
					              {{ sub_order.m_status }}
					            </span>
	              		</td>
	              		<td class="bodytr">
	              			<span v-if="!sub_order.paid_last_at" class="text-primary">{{ t("orders.notYetGenerated") }}</span>
	              			<span v-else>{{ dateFormat(sub_order.paid_last_at, "YYYY/MM/DD hh:mm A") }}</span>
	              		</td>
	              		<td class="bodytr">
	              			<span v-if="!sub_order.delivery_at" class="text-primary">{{ t("orders.notYetGenerated") }}</span>
	              			<span v-else>{{ dateFormat(sub_order.delivery_at, "YYYY/MM/DD hh:mm A") }}</span>
	              		</td>
	              		<td class="bodytr">
	              			<a :href="`/account/period-orders/${sub_order.uuid}`" class="btn btn-primary p-2 mr-2">
					              <i class="fa fa-eye"></i> {{ t("global.view") }}
					            </a>
	              		</td>
	              	</tr>
	              </tbody>
	            </table>
				<div v-if="orders.sub_orders[order.id]" class="d-flex justify-content-center">
					<el-pagination
						v-model:currentPage="orders.sub_orders[order.id].paging.page"
						hide-on-single-page
						:page-size="orders.sub_orders[order.id].paging.limit"
						background
						layout="total, prev, pager, next"
						:total="orders.sub_orders[order.id].paging.total_count"
						@current-change="(val) => handleCurrentChange(val, order.id)"
					/>
				</div>
			</td>
          </tr>
	    	</template>
	    </tbody>
  	</table>
  	<div v-if="!orders.data.length" class="mt-3 mb-2 text-center">
      {{ t("orders.empty") }}
    </div>
    <div v-if="orders.paging" class="card-footer">
      <!-- Pagination-->
      <nav class="d-flex justify-content-between pt-2" aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item">
            <el-button :disabled="orders.paging.page - 1 < 1" @click="handlePrePage">
              <i class="czi-arrow-left mr-2"></i>
              {{ t("paging.prevPage") }}
            </el-button>
          </li>
        </ul>
        <ul class="pagination">
            <li class="page-item d-none d-sm-block">
              <span class="page-link page-link-static">
                {{orders.paging.page}} / {{totalPage}} ({{ t("paging.totalCount", [orders.paging.total_count]) }})
              </span>
            </li>

            <li class="page-item d-sm-none">
              {{ t("paging.totalCount", [orders.paging.total_count]) }}
            </li>
        </ul>
        <ul class="pagination">
            <li class="page-item">
              <el-button :disabled="orders.paging.page + 1 > totalPage" @click="handleNextPage">
                {{ t("paging.nextPage") }}
                <i class="czi-arrow-right ml-2"></i>
              </el-button>
            </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { dateFormat } from "../../utils"
import { _api_getPeriodOrders } from "../../api/index.js";

const { t, n, locale } = useI18n()

const totalPage = computed(() => orders.paging ? Math.ceil(orders.paging.total_count / orders.paging.limit) : null)
const filterParams = reactive({
	parent_id: 0,
  page: 1,
  limit: 10,
})
const orders = reactive({
  data: [],
  paging: null,
  sub_orders: {},
})

const getData = async () => {
  window.fullPageLoading("show")
  try {
    const resp = await _api_getPeriodOrders(filterParams)
    orders.data = resp.data
    orders.paging = resp.paging
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}
const handlePrePage = () => {
  filterParams.page--
  getData()
}
const handleNextPage = () => {
  filterParams.page++
  getData()
}

const subFilterParams = reactive({
	parent_id: null,
	page: 1,
	// limit: 10,
})

const getSubData = async (id) => {
	window.fullPageLoading("show")
  try {
	subFilterParams.parent_id = id
    const resp = await _api_getPeriodOrders(subFilterParams)
    orders.sub_orders[id] = {
    	data: resp.data,
    	paging: resp.paging
    }
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}

const handleCurrentChange = (page, id) => {
	// console.log("handleCurrentChange: ", page)
	subFilterParams.page = page
	getSubData(id)
}

const onClickSubData = (order) => {
	order.display = !order.display
	if (!orders.sub_orders[order.id]) {
		subFilterParams.page = 1
		getSubData(order.id)
	}
}

onMounted(() => {
  getData()
})
</script>